import { useNavigate } from '@tanstack/react-router';
import { IconButton } from '@volvo/vcdk-react';
import React from 'react';

import type { IFleetMember } from '@/service/vpc/types/IFleetMember';

import useMediaQuery from '@/hooks/useMediaQuery';

type Props = {
  member: IFleetMember;
  disabled: boolean;
  isEdit: boolean;
  editRow: () => void;
  saveRow: () => void;
  deleteRows: (selectedRows: IFleetMember[]) => void;
};

const FleetMemberTableOptions: React.FC<Props> = ({ member, disabled, isEdit, editRow, saveRow, deleteRows }) => {
  const { mediaQueryNodes: mq } = useMediaQuery();
  const navigate = useNavigate();

  const mqSize = mq({
    default: 'mobile',
    md: 'desktop',
  });

  return (
    <div className="flex justify-end gap-4">
      {mqSize === 'mobile' ? (
        <IconButton
          icon="edit"
          size="medium"
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            navigate({ to: `/members/${member.endUserId}/` });
          }}
        />
      ) : isEdit ? (
        <IconButton
          icon="floppy-disk"
          size="medium"
          onClick={(e) => {
            e.preventDefault();
            saveRow();
          }}
        />
      ) : (
        <IconButton
          icon="edit"
          size="medium"
          disabled={disabled}
          onClick={(e) => {
            e.preventDefault();
            editRow();
          }}
        />
      )}
      <IconButton
        icon="trash"
        size="medium"
        disabled={disabled || isEdit}
        onClick={(e) => {
          e.preventDefault();
          deleteRows([member]);
        }}
      />
    </div>
  );
};

export default FleetMemberTableOptions;
